import { useEffect, useRef } from 'react'
import { FRAMER_SLIDEINLEFT } from './framer-animations'
import { useStore } from './context'
import { useObserver } from 'mobx-react-lite'
// export const waitForAnimation = (fn) =>
// 	setTimeout(fn, 1000 * FRAMER_PAGE_TRANSITION_DURATION)

export const makeSlug = (article) => {
	return 	`/${article.category.toLowerCase()}/${article.slug}`
}


export function encodeToUrlParams(arr, key) {
    if (!Array.isArray(arr) || typeof key !== 'string') {
        throw new Error('Invalid arguments. Expected an array and a string.');
    }
    const urlSearchParams = new URLSearchParams();
    arr.forEach((item, index) => {
        urlSearchParams.append(`${key}[]`, item);
    });
    return urlSearchParams.toString();
}

export function decodeFromUrlParams(urlParams, key) {
    const urlSearchParams = new URLSearchParams(urlParams);
    // let result = {};
	return urlSearchParams.getAll(`${key}[]`)
    // result[key] = urlSearchParams.getAll(`${key}[]`);
    // return result;
}



function isIOS() {
	if (/iPad|iPhone|iPod/.test(navigator.platform)) {
	  return true;
	} else {
	  return navigator.maxTouchPoints &&
		navigator.maxTouchPoints > 2 &&
		/MacIntel/.test(navigator.platform);
	}
}

export function checkIsMobile() {
	let check = false
	// ;(function (a) {
	// 	if (
	// 		/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
	// 			a
	// 		) ||
	// 		/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
	// 			a.substr(0, 4)
	// 		)
	// 	)
	// 		check = true
	// })(navigator.userAgent || navigator.vendor || window.opera)
	
	// if (/mobile/i.test(navigator.userAgent) && !/ipad|tablet/i.test(navigator.userAgent)) {
	// 	check = true;
	// }
	if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
		// some code..
		check = true;
	}
	
	if (isIOS()) {
		check = true;
	}

	return check
}

export const decimalHash = (string) => {
	let sum = 0
	for (let i = 0; i < string.length; i++)
		sum += ((i + 1) * string.codePointAt(i)) / (1 << 8)
	return sum % 1
}

export function getContentfulImageURL(src, w = 1000, q = 80, fm = 'webp') {
	if (!src) {
		console.error('missing image src')
		return ''
	}

	let url = src
	if (typeof src === 'object' && src.url) {
		url = src.url
	}

	return `${url}?w=${w}&q=${q}&fm=${fm}`
}

export function hexToRgbaString(hex, opacity = 1) {
	var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
	return result
		? `rgba(${parseInt(result[1], 16)},${parseInt(result[2], 16)},${parseInt(
				result[3],
				16
		  )},${opacity})`
		: null
}

export function modulePaddingSerializer(padding) {
	if (padding === 'None') {
		return 0
	}
	if (padding === 'Small') {
		return 'var(--padding-s)'
	}
	if (padding === 'Medium') {
		return 'var(--padding-m)'
	}
	if (padding === 'Large') {
		return 'var(--padding-l)'
	}
	return 'auto'
}

export function modulePaddingSerializerMobile(padding) {
	if (padding === 'None') {
		return 0
	}
	if (padding === 'Small') {
		return 'var(--padding-s-mobile)'
	}
	if (padding === 'Medium') {
		return 'var(--padding-m-mobile)'
	}
	if (padding === 'Large') {
		return 'var(--padding-l-mobile)'
	}
	return 'auto'
}

export function moduleHorizontalAlignSerializer(padding) {
	if (padding === 'Start' || padding === 'Left') {
		return 'flex-start'
	}
	if (padding === 'Center') {
		return 'center'
	}
	if (padding === 'End' || padding === 'End') {
		return 'flex-end'
	}
	return 'center'
}

export function moduleVerticalAlignSerializer(padding) {
	if (padding === 'Top') {
		return 'flex-start'
	}
	if (padding === 'Center') {
		return 'center'
	}
	if (padding === 'Bottom') {
		return 'flex-end'
	}

	return 'center'
}

export function moduleAnimationSerializer(amount, direction) {
	if (!amount && !direction) return FRAMER_SLIDEINLEFT.variants
	let amountCoef

	if (amount === 'None') {
		amountCoef = 0
	} else if (amount === 'Small') {
		amountCoef = 1
	} else if (amount === 'Medium') {
		amountCoef = 2
	} else if (amount === 'Large') {
		amountCoef = 5
	} else {
		amountCoef = 1
	}

	let x, y
	if (direction === 'From Bottom') {
		y = 50 * amountCoef
		x = 0
	} else if (direction === 'From Top') {
		y = -50 * amountCoef
		x = 0
	} else if (direction === 'From Left') {
		y = 0
		x = -50 * amountCoef
	} else if (direction === 'From Right') {
		y = 0
		x = 50 * amountCoef
	} else {
		y = 0
		x = -50 * amountCoef
	}

	const variants = {
		inactive: {
			opacity: 0,
			y,
			x,
		},
		active: {
			x: 0,
			y: 0,
			opacity: 1,
		},
	}

	return variants
}

export const useDimensions = (ref) => {
	const dimensions = useRef({ width: 0, height: 0 })

	useEffect(() => {
		dimensions.current.width = ref.current.offsetWidth
		dimensions.current.height = ref.current.offsetHeight
	}, [])

	return dimensions.current
}

export function chunk(array, size) {
    // Validate input parameters
    if (!Array.isArray(array)) {
        throw new TypeError('First argument must be an array.');
    }
    if (typeof size !== 'number' || size <= 0) {
        throw new TypeError('Second argument must be a positive number.');
    }
    
    let result = [];
    
    for (let i = 0; i < array.length; i += size) {
        result.push(array.slice(i, i + size));
    }
    
    return result;
}
